import { render, staticRenderFns } from "./basicSettings.vue?vue&type=template&id=4b4f4cac&scoped=true"
import script from "./basicSettings.vue?vue&type=script&lang=js"
export * from "./basicSettings.vue?vue&type=script&lang=js"
import style0 from "./basicSettings.vue?vue&type=style&index=0&id=4b4f4cac&prod&lang=scss"
import style1 from "./basicSettings.vue?vue&type=style&index=1&id=4b4f4cac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f4cac",
  null
  
)

export default component.exports